import AssignSubProductToQuestionnaireLayout from "./AssignSubProductToQuestionnaireLayout";

export default AssignSubProductToQuestionnaireLayout;
